import { countActionTypes, SETANGLESECTIONLINE } from '../../actions/simulationAdaptation/angleSectionLine'

const reducer = (state = 0, action: countActionTypes): number => {
  switch (action.type) {
    case SETANGLESECTIONLINE:
      return action.payload.n
    default:
      return state
  }
}

export default reducer
